import { useTranslation } from 'react-i18next';
import './style.css';

const MedicalFamilyHistory = ({ data }) => {
    const { t } = useTranslation();
    
    const familyHistory = data?.familyHistory || [
        { id: 1, name: 'Diabetes Type II (Father)' },
        { id: 2, name: 'Hypertension (Mother)' },
        { id: 3, name: 'No History of Joint Failure' }
    ];

    return (
        <div className="patient-medical-family-history-section">
            <div className="patient-medical-family-history-header">
                <div className="patient-medical-family-history-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h3 className="patient-medical-family-history-title">{t('medical-family-history').toUpperCase()}</h3>
            </div>
            <div className="patient-medical-diagnosis-content">
               <span className="patient-medical-family-history-text">
                    {data?.familyMedicalHistory}
                </span>
            </div>
        </div>
    );
};

export default MedicalFamilyHistory;

